import { Dispatch, FC, SetStateAction, useLayoutEffect, useMemo } from 'react';
import { BusinessVariablesList } from './BusinessVariablesList';
import { isEqual } from 'lodash';
import { useSelector } from 'react-redux';
import { getChosenBusiness } from 'store/authentication/selectors';
import { BusinessVariable } from 'components/WYSIWYG/use-merge-fields';
import { BusinessVariableErrors } from './useErrors';

type BusinessVariablesProps = {
  businessVariables: BusinessVariable[];
  setBusinessVariables: Dispatch<SetStateAction<BusinessVariable[]>>;
  errors: BusinessVariableErrors;
  setErrors: Dispatch<SetStateAction<BusinessVariableErrors>>;
  setDirty: (dirty: boolean) => void;
};

export const BusinessVariables: FC<BusinessVariablesProps> = ({
  businessVariables,
  setBusinessVariables,
  errors,
  setErrors,
  setDirty,
}) => {
  const initialData: BusinessVariable[] =
    useSelector(getChosenBusiness)?.business_variables;

  const isDirty = useMemo(() => {
    return !isEqual(businessVariables, initialData);
  }, [initialData, businessVariables]);

  useLayoutEffect(() => {
    setDirty(isDirty);
  }, [setDirty, isDirty]);

  return (
    <BusinessVariablesList
      data={businessVariables}
      setData={setBusinessVariables}
      errors={errors}
      setErrors={setErrors}
    />
  );
};
